module.exports = __webpack_public_path__ + "img/151.newspaper.eab4e988.svg";